import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Box } from "@mui/material";
import { Navbar } from "@/components/navbar";
import { PlatformGuard } from "@/components/platform-guard";
import { NotFoundErrorPage } from "@/lib/error-boundary";
import { ProductionWarningBanner } from "@/components/error-display/production-warning-banner/production-warning-banner";
import { ImpersonationBanner } from "@/features/impersonation";

export const Route = createFileRoute("/_authenticated/driver")({
	component: DriverLayout,
	notFoundComponent: NotFoundErrorPage,
});

function DriverLayout() {
	return (
		<PlatformGuard>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					height: "100dvh",
					overflow: "auto",
				}}
			>
				<ImpersonationBanner />
				<Navbar />
				<ProductionWarningBanner />
				<Box
					component="main"
					sx={{
						flex: 1,
						bgcolor: "background.level1",
						height: "100%",
						overflow: "auto",
					}}
				>
					<Outlet />
				</Box>
			</Box>
		</PlatformGuard>
	);
}
